var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hasBeenDismissed
    ? _c("nudge-message", {
        attrs: {
          "icon-name": _vm.iconName,
          "icon-style": _vm.iconStyle,
          "icon-rotation": _vm.iconRotation,
          title: _vm.title,
          content: _vm.content,
          "aria-label-close": _vm.ariaLabelClose,
          "pointer-orientation-y": _vm.pointerOrientationY,
          "pointer-orientation-x": _vm.pointerOrientationX,
          "pointer-position-x": _vm.pointerPositionX,
        },
        on: { "dismiss-nudge": _vm.dismissNudge },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }